import { showErrorAxios } from "infra/helpers/alerta";
import http from "infra/http";
import { useMutation, useQueryClient } from "react-query";
import { IndexadorCreateOrUpdateRequest } from "../typings";

function useCreateIndexador() {
  const queryClient = useQueryClient();

  return useMutation(
    "create/v1/indexador/:id",
    ({ data }: { data: IndexadorCreateOrUpdateRequest }) =>
      http.post('/v1/indexador', data),
    {
      retry: false,
      onSuccess: () => {
        queryClient.invalidateQueries("/v1/indexador");
      },
      onError: (e) => {
        showErrorAxios(e)
      }
    }
  );
}

export default useCreateIndexador;
